import { render, staticRenderFns } from "./rte.vue?vue&type=template&id=7871c9d4&"
import script from "./rte.vue?vue&type=script&lang=js&"
export * from "./rte.vue?vue&type=script&lang=js&"
import style0 from "./rte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports